import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { RESIDENTS_DESKTOP_COLORS } from '@/constants/residents/desktop/color';

interface EmptyStateViewProps {
  icon: React.ReactNode;
  title: string;
  message: string;
}

export const EmptyStateView: React.FC<EmptyStateViewProps> = ({ icon, title, message }) => {
  return (
    <View style={styles.container}>
      <View style={styles.iconContainer}>
        {icon}
      </View>
      <Text style={styles.title}>{title}</Text>
      <Text style={styles.message}>{message}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 32,
    paddingHorizontal: 16,
  },
  iconContainer: {
    marginBottom: 16,
  },
  title: {
    fontSize: 16,
    fontWeight: '700',
    color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY,
    marginBottom: 8,
    textAlign: 'center',
  },
  message: {
    fontSize: 14,
    color: RESIDENTS_DESKTOP_COLORS.TEXT_TERTIARY,
    textAlign: 'center',
    lineHeight: 20,
  },
});
